export default function Address() {
  this.addressID = null
  this.foreignAddress = false
  this.address1 = ''
  this.address2 = ''
  this.city = ''
  this.state = ''
  this.zip = ''
  this.area = ''
  this.country = ''
}